import { render, staticRenderFns } from "./WhatIsIt.vue?vue&type=template&id=65cd2b79&scoped=true&"
import script from "./WhatIsIt.vue?vue&type=script&lang=js&"
export * from "./WhatIsIt.vue?vue&type=script&lang=js&"
import style0 from "./WhatIsIt.vue?vue&type=style&index=0&id=65cd2b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd2b79",
  null
  
)

export default component.exports